<nb-card class="dialog-card">
  <nb-card-header>{{ model.id ? 'Editar usuário' : 'Novo usuário' }}</nb-card-header>
  <nb-card-body>
    <div class="grid">
      <label>Login<input nbInput fullWidth [(ngModel)]="model.login" name="login" /></label>
      <label>Nome<input nbInput fullWidth [(ngModel)]="model.nome" name="nome" /></label>
      <label>CPF<input nbInput fullWidth [(ngModel)]="model.cpf" name="cpf" /></label>
      <label>Telefone<input nbInput fullWidth [(ngModel)]="model.telefone" name="telefone" /></label>
      <label class="full">E-mail<input nbInput fullWidth [(ngModel)]="model.email" name="email" /></label>
    </div>
    <div class="flags">
      <nb-checkbox [(ngModel)]="model.admin" name="admin">Administrador</nb-checkbox>
      <nb-checkbox [(ngModel)]="model.coordenacao" name="coord">Coordenação</nb-checkbox>
      <nb-checkbox [(ngModel)]="model.catequista" name="cat">Catequista</nb-checkbox>
    </div>
    <p class="hint">O acesso ao sistema (senha) é gerenciado pelo provedor de identidade; aqui você define perfil e vínculos no sistema.</p>
  </nb-card-body>
  <nb-card-footer class="footer-actions">
    <button nbButton status="basic" (click)="fechar()">Cancelar</button>
    <button nbButton status="primary" (click)="salvar()">Salvar</button>
  </nb-card-footer>
</nb-card>
